import { render, staticRenderFns } from "./SelectProfissional.vue?vue&type=template&id=29b8205c"
import script from "./SelectProfissional.vue?vue&type=script&lang=js"
export * from "./SelectProfissional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports